import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

const toType = (obj) => {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
};

@Module({namespaced: true, stateFactory: true})
export default class ListModule extends VuexModule {
  items = {};
  selectedGroup = null;
  mode = 'model';

  get getGroups() {
    let mapping = (model) => model.MODNameGrp1;

    if (this.mode === 'make') {
      mapping = (model) => model.make.name;
    }

    if (toType(this.items) === 'object') {
      return [];
    }

    const groups = this.items.map(mapping).sort();

    return [...new Set(groups)];
  }

  get getSelectedGroup() {
    return this.selectedGroup;
  }

  get getItemsFromSelectedGroup() {
    if (!this.selectedGroup) {
      return this.items;
    }

    let filter = (item) => item.MODNameGrp1 === this.selectedGroup;

    if (this.mode === 'make') {
      filter = (item) => item.make.name === this.selectedGroup
    }

    return this.items.filter(filter);
  }

  @Mutation
  setItems(items) {
    this.items = items;
  }

  @Mutation
  setSelectedGroup(group) {
    if (this.selectedGroup === group) {
      this.selectedGroup = null;
      location.hash = '';
      return;
    }

    location.hash = group;
    this.selectedGroup = group;
  }

  @Mutation
  setMode(mode) {
    this.mode = mode;
  }

  @Action
  fetchAll(items) {
    const commit = this.context.commit;

    this.context.commit('setItems', items);
  }

  @Action
  selectGroup(group) {

    if (!_.includes(this.context.getters.getGroups, group) && group  != "") {
      return;
    }

    this.context.commit('setSelectedGroup', group);
  }
}
